import  Navd  from "./nav_3.js";

export default function Skills() {
  return (
      <div >
    <h1> </h1>
     <h1> </h1>
    
<div>
    
        <Navd Data="/data" Algorithms="/algorithms"  Codes="/codes" Consulting="/consulting" />

     <p> </p>
              
    <h3 className="blue"> Tech Stack </h3>
          
          <div className="black">
          <h4> "Go-to" Full-Stack: React, Python, Java, SQL </h4>
          <h4> Machine Learning | AI | Data: TensorFlow, NumPy, pandas, SciPy, matplotlib </h4>
          </div>
    
    <p> </p>
          <a className="github" href="https://github.com/TREYCSE/GitHub_Portfolio"> GitHub - Click here for the accompanying README.md for code snippets and more </a>

    
    </div>
    
      </div>
    )
  }
/*
<p> Research, Development, Troubleshooting and Debugging </p>
 Tools | Technologies
 <h2 className="blue"> Administrative | Consulting | Management</h2>
 <p> Project planning and scope management: Microsoft Suite & Google Suite </p>
 <p> Research: experience navigating various types of databases </p>
           <p> Big Data tools: Google Cloud, AWS, Azure, Spark </p>

          <hr className="hrhr"></hr>

        <h1 className="white">Skills</h1>
        <h3> click buttons below for code samples, results, summaries, visuals, and more from my completed and in-progress projects! </h3>

*/
